<div
  [ngClass]="displayOnTopBar() ? 'conversation-title-top-bar' : 'conversation-title-preview'"
  [class.closed-or-deleted]="isInternalInfoDeleted() || conversationClosed()"
>
  {{ formattedTitle() | translate }}
</div>
